import React from "react"
import { CircularProgress, Paper, Card, CardText, FontIcon, Drawer, TableHeader, TableRow, TableHeaderColumn, TableRowColumn, TableBody  } from "material-ui"
import Table from "../../../components/common/Table"
import TableActionBar from "../../../components/layout/TableActionBar"
import AccountManagerClientTabDrawer from "./client_tab_details/AccountManagerClientTabDrawer"
import strings from "../../../localization/strings"
import * as api from "../../../api"
import { IAccountManagerMarketingFunnel, IAccountManagerFunnelStage, IAccountFunnelDTO, ETypeOfBusiness, ESizeOfBusiness } from "../../../models"
import moment from "moment"
import ToolTip from "react-portal-tooltip"
import AppStateStore from "../../../stores/AppStateStore"

interface IState {
    marketingFunnelData: IAccountManagerMarketingFunnel
    loading: boolean
    accountDrawerOpen: boolean
    clickedStage: IAccountManagerFunnelStage
    clickedStageFilteredAccounts: IAccountFunnelDTO[]
    offset: number
    total: number
	limit: number
	limitOptions: number[]
    searchText: string
    marketingInfoToolTipOpen: boolean
    clickedInfoAccount: IAccountFunnelDTO
    accountDetailDrawerOpen: boolean
    selectedAccountId: string
}

export default class AccountManagerDetailsMarketingFunnelTab extends React.Component<{}, IState> {
    constructor(props) {
        super(props)
        this.state = {
            marketingFunnelData: null,
            loading: true,
            accountDrawerOpen: false,
            clickedStage: null,
            clickedStageFilteredAccounts: [],
            total: 0,
            offset: 0,
			limit: 15,
			limitOptions: [15, 50, 100],
            searchText: "",
            marketingInfoToolTipOpen: false,
            clickedInfoAccount: null,
            accountDetailDrawerOpen: false,
            selectedAccountId: null,
        }

    }

    componentDidMount(): void {
        this.getMarketingFunnelData()
    }

    getMarketingFunnelData() {
        this.setState({ loading: true }, () => {
            api.getMarketingFunnelData().then(res => {
                this.setState({
                    loading: false,
                    marketingFunnelData: res.data as IAccountManagerMarketingFunnel
                })
            })
        })
    }

    getFilteredAccounts(accounts: IAccountFunnelDTO[]) {
		const filteredAccounts = accounts ? accounts.filter(item => !this.state.searchText || item.Name.toLowerCase().includes(this.state.searchText.toLowerCase())) : []
		const clickedStageFilteredAccounts = filteredAccounts ? filteredAccounts.filter((_v, index) => index >= this.state.offset && index < this.state.offset + this.state.limit) : []
		this.setState({ clickedStageFilteredAccounts, total: filteredAccounts.length })
	}

    render() {
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        })
        return (
            <div style={{ padding: 30 }}>
                <h2 style={{ marginTop: 0 }}>{strings.Marketing_Funnel}</h2>
                {this.state.loading ? <div className="spinner"><CircularProgress /></div> 
                :
                <div>
                    <div className="marketing-funnel-header" style={{ backgroundColor: "#4b4a4a", color: "#b5b5b5", display: "flex", minHeight: 150, alignItems: "center", justifyContent: "space-between", }}>
                        <div style={{  marginLeft: 50, marginRight: 30 }}>
                            <h1 style={{ fontSize: 50, fontWeight: "bold", textAlign: "center", margin: 0 }}>Filters Coming Soon!</h1>
                        </div>
                        <div style={{...verticalLine}}></div>
                        <div style={{ marginLeft: 30, marginRight: 30 }}>
                            <h1 style={{ fontSize: 70, fontWeight: "bold", textAlign: "center", margin: 0 }}>{this.state.marketingFunnelData.PotentialClientsInFunnel.toLocaleString()}</h1>
                            <p style={{ fontSize: 15, fontWeight: "bold", margin: 5 }}>{strings.Potential_Clients_In_Funnel.toUpperCase()}</p>
                        </div>
                        <div style={{...verticalLine}}></div>
                        <div style={{ marginLeft: 30, marginRight: 30 }}>
                            <div style={{ fontSize: 30, }}><strong>{strings.LTV}: </strong>{formatter.format(this.state.marketingFunnelData.TotalLTV)}</div>
                            <div style={{ fontSize: 30, marginTop: 20, }}><strong>{strings.CAC}: </strong>{formatter.format(this.state.marketingFunnelData.TotalCAC)}</div>
                        </div>
                        <div style={{...verticalLine}}></div>
                        <div style={{ marginLeft: 30, marginRight: 70 }}>
                            <div style={{ fontSize: 70, textAlign: "center" }}><strong>{`${strings.LTV}:${strings.CAC} `}</strong>{this.state.marketingFunnelData.LTVToCACRatio}</div>
                        </div>
                    </div>
                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                        {this.state.marketingFunnelData.Stages.slice().sort((a,b) => a.Order - b.Order).map((item, index, arr) => (
                            <div style={{ display: "flex", alignItems: "center" }} key={index}>
                                <Paper zDepth={1} style={{ minWidth: 300, margin: "20px 10px 0px 10px" }}>
                                    <Card>
                                        <CardText>
                                            <h1 style={{ fontSize: 15 ,marginTop: -15 }}>{item.Name}</h1>
                                            <h1 style={{ fontSize: 35, marginTop: -10 }}>{item.NumberOfItemsInStage.toLocaleString()}</h1>
                                            <p style={{ marginBottom: 0 }}><strong>{strings.Cost_Per}: </strong>{formatter.format(item.CostPerItemInStage)}</p>
                                            <p style={{ margin: 0 }}><strong>{strings.LTV}: </strong>{formatter.format(item.TotalLTVInStage)}</p>
                                            {!item.NonAccountStage &&
                                                <FontIcon 
                                                    style={{ fontSize: 18, float: "right", margin: "0px 0px 5px 0px", cursor: "pointer" }} 
                                                    className={"fa fa-external-link"}
                                                    onClick={() => this.setState({ accountDrawerOpen: true, clickedStage: item }, () => this.getFilteredAccounts(item.Accounts))}
                                                />
                                            }
                                        </CardText>
                                    </Card>
                                </Paper>
                                {index !== arr.length - 1 && <span>―{typeof(item.ConversionPercentageToNextStage) === "number" ? item.ConversionPercentageToNextStage.toFixed(2) : item.ConversionPercentageToNextStage}%→</span>}
                            </div>
                        ))}
                    </div>
                </div>
                }

                {/* Stage Accounts Drawer */}
                <Drawer
                    open={this.state.accountDrawerOpen}
                    openSecondary
                    docked={false}
                    width={1050}
                    style={{ maxWidth: 1050, zIndex: 999 }}
                    containerStyle={{ overflow: "unset" }}
                    onRequestChange={() => this.setState({ accountDrawerOpen: false })}
                >
                    {this.state.accountDrawerOpen && 
                        <div>
                            <div style={{ padding: 15, backgroundColor: AppStateStore.getFrontEndSettings().UISettings.AccentColor , height: 70 }}>
                                <h2 style={{ color: "#ffffff" }}>
                                    <span style={{ marginRight: 7 }}>
                                        {`${strings.Account}s ${strings.In} ${strings.Stage} "${this.state.clickedStage.Name}"`}
                                    </span>
                                    <i className="fa fa-close itemActionButton" style={{ float: "right" }} onClick={() => this.setState({ accountDrawerOpen: false })} />
                                </h2>
                            </div>

                            <div style={{ padding: 10 }}>
                                <TableActionBar
                                    onSearch={searchText => this.setState({ searchText, offset: 0 }, () => this.getFilteredAccounts(this.state.clickedStage.Accounts))}
                                    searchText={this.state.searchText}
                                    readonly={true}
                                />
                                {!this.state.clickedStageFilteredAccounts.length ?
                                    <h2 style={{ textAlign: "center", marginTop: 25 }}>
                                        {strings.No_employee_found.replace(strings.Employee.toLowerCase(), strings.Account)}
                                    </h2> 
                                    :
                                    <Table
                                        allowClickRow
                                        items={this.state.clickedStageFilteredAccounts} 
                                        handleClickRow={(row) => this.setState({ selectedAccountId: row.Id, accountDetailDrawerOpen: true })}
                                        total={this.state.total}
                                        offset={this.state.offset}
                                        limit={this.state.limit}
                                        limitOptions={this.state.limitOptions}
                                        onPageClick={offset => this.setState({ offset }, () => this.getFilteredAccounts(this.state.clickedStage.Accounts))}
                                        onLimitChange={limit => this.setState({ limit, offset: 0 }, () => this.getFilteredAccounts(this.state.clickedStage.Accounts))}
                                        bodyStyle={{ overflow: "visible" }}
                                        readonly={true}
                                    >
                                        <TableHeader>
                                            <TableRow>
                                                <TableHeaderColumn style={{ width: 50, textAlign: "center" }}>{strings.Name}</TableHeaderColumn>
                                                <TableHeaderColumn style={tableCol}>{strings.Company_Type}</TableHeaderColumn>
                                                <TableHeaderColumn style={tableCol}>{strings.Company_Size}</TableHeaderColumn>
                                                <TableHeaderColumn style={tableCol}>{strings.Marketing_Info}</TableHeaderColumn>
                                                <TableHeaderColumn style={tableCol}>{strings.Enter_Stage_Date}</TableHeaderColumn>
                                                <TableHeaderColumn style={tableCol}>{strings.No_Of_Punching_Employees}</TableHeaderColumn>
                                                <TableHeaderColumn style={tableCol}>{strings.Total_Potential_Employees}</TableHeaderColumn>
                                                <TableHeaderColumn style={tableCol}>{strings.Total_Expected_Employees}</TableHeaderColumn>
                                                <TableHeaderColumn style={tableCol}>{strings.Earnings_PEPM}</TableHeaderColumn>
                                            </TableRow>
                                        </TableHeader>
                                        <TableBody showRowHover deselectOnClickaway={false}>
                                            {this.state.clickedStageFilteredAccounts && this.state.clickedStageFilteredAccounts.map((row, i) =>
                                                <TableRow key={i}>
                                                    <TableRowColumn title={row.Name} style={{ width: 50, textAlign: "center" }}>{row.Name}</TableRowColumn>
                                                    <TableRowColumn title={strings[ETypeOfBusiness[row.CompanyType]]} style={tableCol}>{strings[ETypeOfBusiness[row.CompanyType]]}</TableRowColumn>
                                                    <TableRowColumn title={strings[ESizeOfBusiness[row.CompanySize]]} style={tableCol}>{strings[ESizeOfBusiness[row.CompanySize]]}</TableRowColumn>
                                                    <TableRowColumn style={tableCol}>
                                                        <FontIcon
                                                            id={`marketingInfo-${row.Id}`}
                                                            className="fa fa-info-circle"
                                                            style={{ fontSize: 16, color: "#777777", cursor: "pointer" }}
                                                            onMouseEnter={() => this.setState({ marketingInfoToolTipOpen: true, clickedInfoAccount: row })}
                                                            onMouseOut={() => this.setState({ marketingInfoToolTipOpen: false, clickedInfoAccount: null })}
                                                        />
                                                    </TableRowColumn>
                                                    <TableRowColumn title={moment(row.EnterStageDate).format("HH:mm MM/DD/YYYY")} style={tableCol}>{moment(row.EnterStageDate).format("HH:mm MM/DD/YYYY")}</TableRowColumn>
                                                    <TableRowColumn title={row.NumberOfPunchingEmployees} style={tableCol}>{row.NumberOfPunchingEmployees}</TableRowColumn>
                                                    <TableRowColumn title={row.TotalPotentialEmployees} style={tableCol}>{row.TotalPotentialEmployees}</TableRowColumn>
                                                    <TableRowColumn title={row.TotalExpectedEmployees} style={tableCol}>{row.TotalExpectedEmployees}</TableRowColumn>
                                                    <TableRowColumn title={row.EarningsPerEmployeePerMonth} style={tableCol}>{row.EarningsPerEmployeePerMonth}</TableRowColumn>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                }
                                {this.state.marketingInfoToolTipOpen &&
                                    <ToolTip active={this.state.marketingInfoToolTipOpen} position="right" arrow="center" parent={`#marketingInfo-${this.state.clickedInfoAccount && this.state.clickedInfoAccount.Id}`}>
                                        <div style={{ padding: 5, width: 200, }}>
                                        <p><strong>{strings.UTMSource}: </strong>{this.state.clickedInfoAccount.MarketingInfo.UtmSource}</p> 
                                        <p><strong>{strings.UTMMedium}: </strong>{this.state.clickedInfoAccount.MarketingInfo.UtmMedium}</p>
                                        <p><strong>{strings.UTMCampaign}: </strong>{this.state.clickedInfoAccount.MarketingInfo.UtmCampaign}</p> 
                                        <p><strong>{strings.UTMTerm}: </strong>{this.state.clickedInfoAccount.MarketingInfo.UtmTerm}</p> 
                                        <p><strong>{strings.UTMContent}: </strong>{this.state.clickedInfoAccount.MarketingInfo.UtmContent}</p>
                                        <p><strong>{strings.AdId}: </strong>{this.state.clickedInfoAccount.MarketingInfo.AdId}</p> 
                                        <p><strong>{strings.AdsetId}: </strong>{this.state.clickedInfoAccount.MarketingInfo.AdsetId}</p>
                                        <p><strong>{strings.CampaignId}: </strong>{this.state.clickedInfoAccount.MarketingInfo.CampaignId}</p> 
                                        <p><strong>{strings.AdName}: </strong>{this.state.clickedInfoAccount.MarketingInfo.AdName}</p> 
                                        <p><strong>{strings.AdsetName}: </strong>{this.state.clickedInfoAccount.MarketingInfo.AdsetName}</p> 
                                        <p><strong>{strings.CampaignName}: </strong>{this.state.clickedInfoAccount.MarketingInfo.CampaignName}</p> 
                                        <p><strong>{strings.Placement}: </strong>{this.state.clickedInfoAccount.MarketingInfo.Placement}</p> 
                                        <p><strong>{strings.SiteSourceName}: </strong>{this.state.clickedInfoAccount.MarketingInfo.SiteSourceName}</p> 
                                        <p><strong>{strings.LandingPage}: </strong>{this.state.clickedInfoAccount.MarketingInfo.LandingPage}</p> 
                                        </div>
                                    </ToolTip>
                                }
                            </div>
                        </div>
                    }
                </Drawer>

            {/* Stage Account Detail Drawer */}
                <AccountManagerClientTabDrawer
                    accountId={this.state.selectedAccountId}
                    editDrawer={true}
                    drawerOpen={this.state.accountDetailDrawerOpen}
                    closeDrawer={() => this.setState({ accountDetailDrawerOpen: false, selectedAccountId: null })}
                    reloadData={() => null}
                />
            </div>
        )
    }
}

const verticalLine: React.CSSProperties = {
    borderLeft: "3px solid #b5b5b5",
    height: 120,
    marginTop: 10
}

const tableCol: React.CSSProperties = {
    width: 120,
    textAlign: "center"
}
